<template lang="pug">
  .flow-builder-gallery-template
    template-tools(v-if="!disabled", @delete="$emit('delete')")
    .template-platforms-container.badges.mb-3(v-if="disabled")
      b-badge(v-for="(platform, platform_index) in selectedPlatformsObjects.slice(0, sliceEnd)", :key="platform.platform_id", :style="{'background-color': platformColor(platform.name, 0.7)}") {{ platform.title }}
      b-badge(v-if="selectedPlatformsObjects.slice(sliceEnd).length", variant="soft-secondary") {{ selectedPlatformsObjects.slice(sliceEnd).length }} más
    .template-platforms-container.overflow-x.no-wrap.mb-3(v-else)
      b-form-group
        label.text-help.text-sm Plataformas donde se usará este template:
        k-select.disabled-white.flush(placeholder="- Agregar plataformas -", :options="parsedPlatforms", :disabled="disabled", :value="selected_platforms", @input="updatePlatforms", multiple, :limit="3", :searchable="false")
    b-card.mb-0.no-shadow.w-100.bg-light-white
      .bg-white.mb-3
        p.mb-0 Mensaje de texto aleatorio
        p.text-secondary.text-sm Envía un mensaje de texto aleatorio de entre las opciones creadas.
      .gallery-elements-row.mb-3(:id="'gallery_elements_' + template_id + '_' + disabled")
        random-text-element(v-for="element in Elements", :key="element.element_id", v-if="element.type === 'random_text'", :id="`element_${element.element_id}`", :disabled="disabled", :block_id="block_id", v-bind="element", @destroy="destroyTemplateElement(element)")
        .add-generic-template.not-draggable(v-if="!disabled", @click="createTemplateElement")
          p.mb-0.text-center Agregar elemento +
</template>

<script>
import templateCommon from '@/helpers/template-common'
import RandomTextElement from '@/components/templates/RandomTextElement.vue'
import TemplateTools from '@/components/templates/common/Tools.vue'
import _debounce from 'lodash.debounce'

export default {
  mixins: [templateCommon],
  components: {
    RandomTextElement,
    TemplateTools
  },
  mounted () {
    this.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
      if (collapseId == `filter_by_parent_attributes_collapse_${this.template_id}`) {
        setTimeout(() => {
          this.repaintBlock()
        }, 500)
      }
    })
  },
  created () {
    this.createTemplateElement = () => {
      let self = this
      let element = {
        type: 'random_text',
        number: self.Elements.length + 1,
        attributes: [
          {
            name: 'text',
            value: ''
          }
        ],
        connectors: []
      }
      this.createElement(this.block_id, this.template_id, element)
    }

    this.destroyTemplateElement = (element) => {
      this.destroyElement(this.block_id, this.template_id, element)
    }
  },
}
</script>

<style lang="scss" scoped>
  @import '@/assets/colors.scss';

  .flow-builder-gallery-template {
    flex: 1 0 auto;
    width: 100%;
    background-color: transparent;
    position: relative;

    .gallery-elements-row {
      display: inline-flex;
      align-items: flex-start;
      justify-content: flex-start;
      white-space: normal;
      width: 100%;
      position: relative;
    }

    .add-generic-template {
      flex: 0 0 auto;
      min-width: 0;
      width: 100%;
      height: 50px;
      max-width: 70%;
      border-radius: 1rem;
      word-break: break-word;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 15px;

      border: 1.5px dashed $light-primary;
      background-color: transparent;
      color: $light-primary !important;
      cursor: pointer;
    }
  }
</style>
